(() => {
  const desktopMedia = window.matchMedia('(min-width: 750px)');

  const updateFooterMenus = ({ matches }) => {
    document.querySelectorAll('.alhaq-footer__menu').forEach((menu) => {
      if (matches) {
        menu.setAttribute('open', '');
      } else {
        menu.removeAttribute('open');
      }
    });
  };

  updateFooterMenus(desktopMedia);
  desktopMedia.addEventListener('change', updateFooterMenus);
})();
